import { render } from "./import_list.vue?vue&type=template&id=664b5715"
import script from "./import_list.vue?vue&type=script&lang=js"
export * from "./import_list.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/import_list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "664b5715"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('664b5715', __exports__)) {
    api.reload('664b5715', __exports__)
  }
  
  module.hot.accept("./import_list.vue?vue&type=template&id=664b5715", () => {
    api.rerender('664b5715', render)
  })

}


export default __exports__